import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import { LoginUpdate } from '../models/login-update.model';
import { Permission } from '../models/login.model';
import { IUser } from '../models/user.model';


@Injectable({
  providedIn: 'root',
})
export class LoginService {
  apiUrl: string;
  baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.baseUrl = baseUrl;
    this.apiUrl = baseUrl + 'api/auth/';
  }

  login(login: string, password: string) {
    const headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = this.apiUrl + 'login';
    const body = {
      username: login,
      password: password
    };

    this.setMqttToken(login, password);

    return this.httpClient.post(url, JSON.stringify(body), { headers: headerOptions })
      .pipe(
        tap(response => this.setSession(response))
      );
  }

  create(login: LoginUpdate) {
    const headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post(this.baseUrl + 'api/login', JSON.stringify(login), { headers: headerOptions });
  }

  update(login: LoginUpdate) {
    const headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put(this.baseUrl + 'api/login', JSON.stringify(login), { headers: headerOptions });
  }

  delete(id: number) {
    const headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.delete(this.baseUrl + 'api/login/' + String(id));
  }

  private setSession(authResult) {
    const expiresAt = moment(authResult.expiresAt);
    localStorage.setItem('token', authResult.token);
    localStorage.setItem('expiresAt', JSON.stringify(expiresAt.valueOf()));
    localStorage.setItem('user', JSON.stringify(authResult.user));
    localStorage.setItem('isSuperAdmin', authResult.isSuperAdmin);
    localStorage.setItem('loginCompanies', JSON.stringify(authResult.loginCompanies));
    localStorage.setItem('selectedCompany', authResult.loginCompanies[0].companyId);
    localStorage.setItem('permission', authResult.loginCompanies[0].permissionType);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('mqttToken');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('user');
    localStorage.removeItem('isSuperAdmin');
    localStorage.removeItem('selectedCompany');
    localStorage.removeItem('loginCompanies');
  }

  isSuperadmin() {
    return JSON.parse(localStorage.getItem('isSuperAdmin'));
  }

  isAdmin() {
    const permission = localStorage.getItem('permission');
    const parsedPermission = +JSON.parse(permission);
    return parsedPermission == Permission.Admin;
  }

  isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    const expiration = localStorage.getItem('expiresAt');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }

  getUser(): IUser {
    const user = localStorage.getItem('user');
    return JSON.parse(user);
  }

  setMqttToken(login, password) {
    let token = login + ":" + password;
    token = btoa(token);

    localStorage.setItem('mqttToken', token);
  }

  getMqttToken() {
    let credentials = localStorage.getItem('mqttToken');
    credentials = atob(credentials);
    return credentials;
  }
}
